function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

var currentPathName = window.location.pathname;
var pathNamesegments = currentPathName.split('/');
var currentHandleName = pathNamesegments.pop();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    // Store original click handler
    this.posterClickHandler = (e) => {
      // Only load if not already loaded
      if (!this.getAttribute('loaded')) {
        this.loadContent(true);
      } else {
        // If already loaded, try to play the video
        const video = this.querySelector('video');
        if (video) {
          video.play().then(() => {
            if (poster) {
              poster.style.display = 'none';
            }
          }).catch(() => {});
        }
      }
    };
    poster.addEventListener('click', this.posterClickHandler);
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    
    // Detect Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
                     (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1);
    
    const poster = this.querySelector('.deferred-media__poster');
    
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      const templateContent = this.querySelector('template').content.firstElementChild.cloneNode(true);
      
      // For video elements, set Safari-required attributes BEFORE appending to DOM
      // Safari requires: autoplay, muted, and playsinline attributes to be present in HTML
      // These must be set before the element is added to the DOM for Safari to recognize them
      if (templateContent.nodeName === 'VIDEO') {
        // CRITICAL for Safari: Set all required attributes before appending to DOM
        // Order matters: set attributes first, then properties
        templateContent.setAttribute('autoplay', '');
        templateContent.setAttribute('muted', '');
        templateContent.setAttribute('playsinline', ''); // Essential for iOS Safari
        templateContent.muted = true; // Also set property (required)
        templateContent.autoplay = true; // Also set property
        
        // Ensure controls are visible
        if (!templateContent.hasAttribute('controls')) {
          templateContent.setAttribute('controls', '');
        }
        
        // Set preload if not already set
        if (!templateContent.hasAttribute('preload')) {
          templateContent.setAttribute('preload', 'auto');
        }
      }
      
      content.appendChild(templateContent);
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      
      if (deferredElement.nodeName == 'VIDEO') {
        // Double-check all Safari-required attributes are set
        deferredElement.setAttribute('autoplay', '');
        deferredElement.setAttribute('muted', '');
        deferredElement.setAttribute('playsinline', '');
        deferredElement.muted = true;
        deferredElement.autoplay = true;
        
        // Ensure video takes full space
        deferredElement.style.width = '100%';
        deferredElement.style.height = '100%';
        deferredElement.style.objectFit = 'cover';
        
        // Hide poster button only after video successfully starts playing
        const hidePoster = () => {
          if (poster) {
            poster.style.display = 'none';
          }
        };
        
        // Show poster button if autoplay fails (especially on Safari)
        const showPosterOnError = () => {
          if (poster) {
            // Keep poster visible if autoplay fails (especially important on Safari)
            poster.style.display = 'flex';
            // Make poster clickable to play video - use addEventListener to not override existing handler
            const playHandler = (e) => {
              e.preventDefault();
              e.stopPropagation();
              deferredElement.play().then(() => {
                hidePoster();
                poster.removeEventListener('click', playHandler);
              }).catch(() => {
                // If play still fails, keep poster visible
              });
            };
            // Remove any existing handler first, then add new one
            poster.removeEventListener('click', playHandler);
            poster.addEventListener('click', playHandler);
          }
        };
        
        // Try to play immediately - Safari needs all attributes set before play()
        const tryPlay = () => {
          // Ensure all Safari-required attributes are still set
          if (!deferredElement.hasAttribute('autoplay')) {
            deferredElement.setAttribute('autoplay', '');
          }
          if (!deferredElement.hasAttribute('muted')) {
            deferredElement.setAttribute('muted', '');
            deferredElement.muted = true;
          }
          if (!deferredElement.hasAttribute('playsinline')) {
            deferredElement.setAttribute('playsinline', '');
          }
          
          // Attempt to play
          const playPromise = deferredElement.play();
          
          if (playPromise !== undefined) {
            playPromise.then(() => {
              // Successfully playing - hide poster
              hidePoster();
            }).catch((error) => {
              // Autoplay failed - show poster (especially important on Safari)
              console.log('Video autoplay failed:', error);
              showPosterOnError();
              // If autoplay fails, try again after video metadata loads
              if (deferredElement.readyState < 2) {
                deferredElement.addEventListener('loadedmetadata', tryPlay, { once: true });
              }
            });
          }
        };
        
        // Wait a tiny bit for Safari to recognize the attributes, then try playing
        // Try playing immediately or wait for metadata
        if (deferredElement.readyState >= 2) {
          // Video already has metadata, try playing after a brief delay for Safari
          setTimeout(tryPlay, 50);
        } else {
          // Wait for video to be ready
          deferredElement.addEventListener('loadedmetadata', () => {
            setTimeout(tryPlay, 50);
          }, { once: true });
          deferredElement.addEventListener('canplay', () => {
            setTimeout(tryPlay, 50);
          }, { once: true });
          deferredElement.addEventListener('loadeddata', () => {
            setTimeout(tryPlay, 50);
          }, { once: true });
        }
        
        // Also listen for play event to hide poster
        deferredElement.addEventListener('play', hidePoster, { once: true });
        
        // Force load the video
        deferredElement.load();
      } else {
        // For non-video elements, hide poster immediately
        if (poster) {
          poster.style.display = 'none';
        }
      }
    } else {
      // If already loaded, try to play the video
      const video = this.querySelector('video');
      if (video && video.paused) {
        video.muted = true;
        video.setAttribute('muted', '');
        if (!video.hasAttribute('controls')) {
          video.setAttribute('controls', '');
        }
        video.play().then(() => {
          if (poster) {
            poster.style.display = 'none';
          }
        }).catch(() => {
          // Show poster if play fails (especially important on Safari)
          if (poster) {
            poster.style.display = 'flex';
            // Make poster clickable to play video
            const playHandler = (e) => {
              e.preventDefault();
              e.stopPropagation();
              video.play().then(() => {
                if (poster) {
                  poster.style.display = 'none';
                }
                poster.removeEventListener('click', playHandler);
              }).catch(() => {});
            };
            poster.removeEventListener('click', playHandler);
            poster.addEventListener('click', playHandler);
          }
        });
      } else if (video && !video.paused) {
        // Video is already playing, hide poster
        if (poster) {
          poster.style.display = 'none';
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

      this.updateMedia();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    // Check if currentVariant exists before accessing its properties
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const color = this.currentVariant[`option${parseInt(this.dataset.colorOptionIndex) + 1 }`]

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      if (color) {
        const handle = color.replace(/\s+/g, '-').toLowerCase();
        mediaGallery.dispatchEvent(new CustomEvent('colorChanged', {
          detail: {
            color: handle,
          },
        }));
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      document.querySelector('.lovelist-wrapper button.swym-button').setAttribute('data-variant-id', this.currentVariant.id);

      const allBISTrigger = document.querySelectorAll('.product_size_variant_popup.active [js-bis-trigger]');
      productForm.querySelectorAll(`[js-bis-trigger]`).forEach((item)=> {
        item.setAttribute('data-variant-id', this.currentVariant.id);
      });
       allBISTrigger.forEach((item)=> {
        item.setAttribute('data-variant-id', this.currentVariant.id);
      });
      document.querySelectorAll('[data-mobile-sticky-waitlist]').forEach((item)=> {
        item.setAttribute('data-variant-id', this.currentVariant.id);
      });
      
      const addToBagDisable = document.querySelector(`#ProductSubmitButton-${this.dataset.section}`); //this is the add to cart or preorder button
      const soldoutBox = document.querySelector(`#product-form-${this.dataset.section} .sold-out`);
      const soldoutMessage = document.querySelector(`.out_of_stock_msg`);
      const inlineBISTrigger = document.querySelector(`#product-form-${this.dataset.section} .bis-trigger-inline`);
      const mobileStickyAtc = document.querySelectorAll('.mobile_sticky_add_box [data-mobile-sticky-atc]');
      const mobileStickyWaitlist = document.querySelectorAll('.mobile_sticky_add_box [data-mobile-sticky-waitlist]');
      const preorderIds = (!!productForm.dataset.preorderVariantIds) ? productForm.dataset.preorderVariantIds.split(",") : [];
      const mobileSizePopupAddCart = document.querySelector('.product_size_variant_popup.active .mobile_size_popup_add_cart');
      const mobileSizePopupSoldOut = document.querySelector('.product_size_variant_popup.active .sold-out');
      const paymentsMessagingContainer = document.getElementById('payments-messaging-container');

      //hide preorder msg
      productForm.querySelector('.preorder-msg')?.classList.add('hidden');
      //rest add to bag text
      addToBagDisable.querySelector('span').innerText = preorderIds.includes(this.currentVariant.id + "") ? window.variantStrings.preorder : window.variantStrings.addToCart;

      // Variant is out of stock
      if (this.currentVariant.inventory_quantity <= 0) {
        if (soldoutBox) soldoutBox.classList.remove('hidden');
        if (inlineBISTrigger) inlineBISTrigger.classList.remove('hidden');
        if (soldoutMessage) soldoutMessage.classList.remove('hidden');
        if (paymentsMessagingContainer) paymentsMessagingContainer.classList.remove('hidden');
        mobileStickyWaitlist.forEach(el => el.classList.remove('hidden'));

        // We are on a gift card product, we always show ATC button
        if (addToBagDisable.getAttribute('data-url') === "physical-gift-card") {
          if (paymentsMessagingContainer) paymentsMessagingContainer.classList.add('hidden');
          addToBagDisable.style.display = "block";
          mobileStickyAtc.forEach(el => {
            el.innerText = window.variantStrings.addToCart;
            el.classList.remove('hidden')
          });
          if (soldoutBox) soldoutBox.classList.add('hidden');
          if (inlineBISTrigger) inlineBISTrigger.classList.add('hidden');
          mobileStickyWaitlist.forEach(el => el.classList.add('hidden'));
          if (soldoutMessage) soldoutMessage.classList.add('hidden');
        } else if (preorderIds.includes(this.currentVariant.id + "")) { // Variant is a preorder variant, we show the ATC button but with preorder text
          addToBagDisable.style.display = "block";
          document.getElementById('payments-messaging-container')?.classList.add('hidden');
          if (inlineBISTrigger) inlineBISTrigger.classList.add('hidden');
          if (soldoutMessage) soldoutMessage.classList.add('hidden');
          mobileStickyWaitlist.forEach(el => el.classList.add('hidden'));
          mobileStickyAtc.forEach(el => {
            el.innerText = window.variantStrings.preorder;
            el.classList.remove('hidden')
          });

          if(mobileSizePopupAddCart) {
            mobileSizePopupAddCart.classList.remove('hidden');
            mobileSizePopupAddCart.querySelector('button').innerText = window.variantStrings.preorder;
          }
          if(mobileSizePopupSoldOut) {
            mobileSizePopupSoldOut.classList.add('hidden');
          }
        } else { // Variant is out of stock and not a preorder variant
          addToBagDisable.style.display = "none";
          mobileStickyAtc.forEach(el => el.classList.add('hidden'));
          mobileStickyWaitlist.forEach(el => el.classList.remove('hidden'));
          if (paymentsMessagingContainer) paymentsMessagingContainer.classList.remove('hidden');

          if(mobileSizePopupAddCart) {
            mobileSizePopupAddCart.classList.add('hidden');
            if(mobileSizePopupSoldOut) {
              mobileSizePopupSoldOut.classList.remove('hidden');
            }
          }
        }

        //chosen variant is a preorder variant, update messaging and button text
        if (preorderIds.includes(this.currentVariant.id + "")) {
          productForm.querySelector('.preorder-msg')?.classList.remove('hidden');
          addToBagDisable.querySelector('span').innerText = window.variantStrings.preorder;
        }
      } else { // Variant is in stock
        if (soldoutBox) soldoutBox.classList.add('hidden');
        if (inlineBISTrigger) inlineBISTrigger.classList.add('hidden');
        if (soldoutMessage) soldoutMessage.classList.add('hidden');
        if (paymentsMessagingContainer) paymentsMessagingContainer.classList.remove('hidden');

        addToBagDisable.style.display = "block";
        mobileStickyAtc.forEach(el => {
          el.innerText = window.variantStrings.addToCart;
          el.classList.remove('hidden')
        });
        mobileStickyWaitlist.forEach(el => el.classList.add('hidden'));

        if(mobileSizePopupAddCart) {
          mobileSizePopupAddCart.querySelector('button').innerText = window.variantStrings.addToCart;
          mobileSizePopupAddCart.classList.remove('hidden');
        }
        if(mobileSizePopupSoldOut) {
          mobileSizePopupSoldOut.classList.add('hidden');
        }
      }
    });

    if (window.location.href.indexOf("digital-gift-card") > -1 || this.dataset.url.indexOf("digital-gift-card") > -1 ) {
      document.querySelector('.mobile_color').innerHTML = "Amount:" + this.currentVariant.option1;
      document.querySelector('#add-to-cart').innerHTML = "Add to bag";
    } else if(window.location.href.indexOf("physical-gift-card") > -1) {

    } else if(this.dataset.url.indexOf("physical-gift-card") > -1  ){

    } else {
      document.querySelector(`#ProductCustomButton-${this.dataset.section}`).classList.add('hidden');
      document.querySelector(`#ProductSubmitButton-${this.dataset.section}`).classList.remove('hidden');
      document.querySelector(`#custom_variant_selector__error-${this.dataset.section}`).style.display = "none";
      if(document.querySelector('.mobile_size')){
        document.querySelector('.mobile_size').innerHTML = "Size:" + this.currentVariant.option2;
        document.querySelector('#add-to-cart').innerHTML = "Add to bag";
      }
    }

    const custominputWrappers = this.querySelectorAll('.product-form__input input');
    custominputWrappers.forEach((mainoption) => {
      mainoption.classList.remove('active');
    });

  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );



        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;

        if(this.dataset.url.indexOf("physical-gift-card") > -1 || this.dataset.url.indexOf("digital-gift-card") > -1 ){
          const destinationMobileQuickModal = document.getElementById(`mobile-price-${this.dataset.section}`);
          const sourceMobileQuickModal = html.getElementById(
          `mobile-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          if (sourceMobileQuickModal && destinationMobileQuickModal) destinationMobileQuickModal.innerHTML = sourceMobileQuickModal.innerHTML;
        }


        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if(this.dataset.url.indexOf("physical-gift-card") > -1 || this.dataset.url.indexOf("digital-gift-card") > -1 ){
          const priceMobileQuickModal = document.getElementById(`mobile-price-${this.dataset.section}`);
          if (priceMobileQuickModal) priceMobileQuickModal.classList.remove('visibility-hidden');
        }
        if (inventorySource && inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          addButtonUpdated.classList.add('hidden'),
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    if (currentHandleName !='digital-gift-card' && currentHandleName !='physical-gift-card') {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
      }

      if (!modifyClass) return;
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      // Return null if no radio is checked (e.g., bundle products where not all options are selected yet)
      return checkedRadio ? checkedRadio.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const loadRecommendations = () => {
      // Avoid duplicate fetches if we've already loaded content
      if (this.classList.contains('product-recommendations--loaded')) return;

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
            return;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    // On mobile, load recommendations immediately so "Pairs Well With" appears faster
    if (window.matchMedia('(max-width: 749px)').matches) {
      loadRecommendations();
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      loadRecommendations();
    };

    new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class SliderComponentProduct extends HTMLElement {
  constructor() {
    super();

    this.gallery = this.closest('media-gallery');
    this.sliderMain = this.querySelector('.product__media-list');
    this.thumbnails = this.gallery.querySelectorAll('[id^="GalleryThumbnails"] .thumbnail-list button');
  }

  connectedCallback() {
    if (window.matchMedia("(max-width: 767px)").matches)
    {
      // Mobile
      this.initSlider();
    }
    else {
      // Desktop
      if(this.gallery.getAttribute("data-desktop-layout") == "stacked")
      {
        this.sliderMain.querySelectorAll('.carousel-cell').forEach((cell) => {
          cell.querySelector('.product-media-container').classList.remove('hidden')
        });
        // Auto-play first video if it exists in stacked layout
        setTimeout(() => {
          const firstSlide = this.sliderMain.querySelector('.carousel-cell');
          if (firstSlide && firstSlide.dataset.mediaType === 'video') {
            const deferredMedia = firstSlide.querySelector('deferred-media');
            if (deferredMedia) {
              deferredMedia.loadContent(false);
            }
          }
        }, 100);
      }
      else
      {
        this.initSlider();
      }
    }
    
    // Also check for videos on initial load (before slider init)
    setTimeout(() => {
      const firstSlide = this.sliderMain.querySelector('.carousel-cell');
      if (firstSlide && firstSlide.dataset.mediaType === 'video') {
        const deferredMedia = firstSlide.querySelector('deferred-media');
        if (deferredMedia && !deferredMedia.getAttribute('loaded')) {
          deferredMedia.loadContent(false);
        }
      }
    }, 200);
  }

  initSlider() {
    const _that = this;
    const allSlidesMain = this.sliderMain.querySelectorAll('.carousel-cell');

    // Delay Flickity init until after first paint
    requestAnimationFrame(() => {
      this.slider = new Flickity(this.sliderMain, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        dragThreshold: 20,
        on: {
          ready: function() {
            allSlidesMain.forEach((cell) => {
              cell.querySelector('.product-media-container').classList.remove('hidden')
            })
          }
        }
      });

      // Helper function to load and play video
      const loadAndPlayVideo = function(slide, userInteracted = true) {
        if (!slide) return;
        
        // Check both data-media-type and if slide contains a deferred-media with video
        const isVideo = slide.dataset.mediaType === 'video' || 
                       slide.querySelector('deferred-media[data-media-id]') !== null;
        
        if (!isVideo) return;
        
        let video = slide.querySelector('video');
        let deferredMedia = slide.querySelector('deferred-media');

        if (video && video.readyState >= 2) {
          // Video already loaded, ensure all Safari-required attributes are set
          video.setAttribute('autoplay', '');
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.muted = true;
          video.autoplay = true;
          if (!video.hasAttribute('controls')) {
            video.setAttribute('controls', '');
          }
          // Only try autoplay if user has interacted (for Safari)
          if (userInteracted) {
            video.play().catch(() => {
              // If autoplay fails, try loading deferred media
              if (deferredMedia && !deferredMedia.getAttribute('loaded')) {
                deferredMedia.loadContent(false);
              }
            });
          }
        } else if (deferredMedia && !deferredMedia.getAttribute('loaded')) {
          // Load the deferred media (video from template)
          // Pass userInteracted flag to loadContent
          deferredMedia.loadContent(false);
        } else if (video) {
          // Video exists but not ready, wait for it and set attributes
          video.setAttribute('autoplay', '');
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.muted = true;
          video.autoplay = true;
          if (!video.hasAttribute('controls')) {
            video.setAttribute('controls', '');
          }
          video.addEventListener('loadeddata', function() {
            if (userInteracted) {
              video.play().catch(() => {});
            }
          }, { once: true });
        } else if (deferredMedia) {
          // Deferred media exists but video not loaded yet
          deferredMedia.loadContent(false);
        }
      };

      this.slider.on('change', function(index) {

        let imgTargetClass = 'mobile-image';
        if (window.innerWidth >= 990) {
          imgTargetClass = 'desktop-image';
        }

        // load all images after slider interaction
        _that.sliderMain
          .querySelectorAll(`img.${imgTargetClass}`)
          .forEach((img) => img.removeAttribute('loading'));

        const currentSlide = allSlidesMain[index];
        _that.updateThumbnails(index);

        // Pause all other media first
        window.pauseAllMedia();
        
        // Load and play video if current slide is a video
        // User has interacted (sliding/navigating), so autoplay should work
        loadAndPlayVideo(currentSlide, true);
      });

      // Auto-play video on initial slide if it's a video
      // On initial load, user hasn't interacted yet, so Safari may block autoplay
      this.slider.on('ready', function() {
        setTimeout(() => {
          const initialIndex = _that.slider.selectedIndex;
          const initialSlide = allSlidesMain[initialIndex];
          // Try autoplay on initial load (may fail on Safari, but poster will be available)
          loadAndPlayVideo(initialSlide, false);
        }, 100);
      });
    });
    
    // Add Intersection Observer as backup to autoplay videos when visible
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            const slide = entry.target.closest('.carousel-cell');
            if (slide) {
              loadAndPlayVideo(slide);
            }
          }
        });
      }, {
        threshold: 0.5,
        rootMargin: '0px'
      });
      
      // Observe all slides for videos
      setTimeout(() => {
        allSlidesMain.forEach(slide => {
          if (slide.dataset.mediaType === 'video' || slide.querySelector('deferred-media')) {
            videoObserver.observe(slide);
          }
        });
      }, 500);
    }
  }


  goToSlide(i) {
    this.slider.select(i);
  }

  updateThumbnails(index) {
    const thumbnail = this.thumbnails[index];
    this.thumbnails
      .forEach((element) => element.removeAttribute('aria-current'));
    thumbnail.setAttribute('aria-current', true);
  }

  destroy() {
    this.slider.destroy();
  }
}

customElements.define('slider-component-product', SliderComponentProduct)